import { render, staticRenderFns } from "./IconGreenCheck.vue?vue&type=template&id=af0b7eb0&"
import script from "./IconGreenCheck.vue?vue&type=script&lang=js&"
export * from "./IconGreenCheck.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports